const stats = [
  { value: "1200+", label: "收录动画" },
  { value: "7天", label: "更新实时同步" },
  { value: "60+", label: "新番推荐" },
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[88vh] w-full items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20warm%20coral%20and%20amber%20gradient%20background%20with%20stylized%20floating%20anime%20movie%20clapperboards%2C%20playful%20doodles%20of%20stars%20and%20film%20reels%2C%20cinematic%20vibrant%20atmosphere%2C%20abstract%20and%20artistic&width=1600&height=1000&seq=hero-bg-2026&orientation=landscape"
          alt="51动漫网新番推荐背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 flex w-full max-w-4xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-calendar-check-line text-accent-300"></i>
          本季新番时间表已更新 · 4月新番火热开播
        </span>

        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          51动漫网
          <span className="mt-3 block text-xl text-background-100/90 md:text-3xl">
            新番时间表 · 追番推荐 · 动画更新一手掌握
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/85 md:text-lg">
          打开51动漫网，直达新番时间表与4月新番推荐，热门动画更新实时同步，追番不再错过每一集。无论你想找本季新番还是回顾经典，这里都能快速定位，满足你的追更需求。
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#schedule"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-8 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-all hover:-translate-y-0.5 hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-calendar-todo-line text-lg"></i>
            查看新番时间表
          </a>
          <a
            href="#recommend"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-8 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap backdrop-blur-sm transition-all hover:-translate-y-0.5 hover:bg-background-50/20 sm:w-auto"
          >
            <i className="ri-fire-line text-lg text-accent-300"></i>
            热门追番推荐
          </a>
        </div>

        <div className="mt-14 grid w-full max-w-xl grid-cols-3 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-2xl border border-background-50/15 bg-background-50/10 px-4 py-4 backdrop-blur-sm"
            >
              <div className="font-heading text-2xl text-accent-300 md:text-3xl">{stat.value}</div>
              <div className="mt-1 text-xs text-background-100/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}